import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  commentCard: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: '24px 0',
    borderBottom: `1px solid ${GRAY_COLORS[200]}`
  },
  commentCardContent: {
    padding: '0 !important'
  },
  commentsFilter: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))
